"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.monitoring-utils");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUtils2 = require("@bit/gerenciatd.utils.metrics");

var _gerenciatdUtils3 = require("@bit/gerenciatd.utils.log-utils");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FETCHING = 'fetching';
var SUCCESS = 'success';
var ERROR = 'error';

var TaggedComponent = /*#__PURE__*/function (_Component) {
  _inherits(TaggedComponent, _Component);

  var _super = _createSuper(TaggedComponent);

  function TaggedComponent(props) {
    var _this;

    _classCallCheck(this, TaggedComponent);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "buildEventObj", function () {
      var kind = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'print';
      var status = arguments.length > 1 ? arguments[1] : undefined;
      var _this$props = _this.props,
          taggingInfo = _this$props.taggingInfo,
          customizerId = _this$props.customizerId;

      var _assertThisInitialize = _assertThisInitialized(_this),
          componentUuid = _assertThisInitialize.componentUuid;

      var newEvent = "".concat(kind, "-").concat(status);

      var event = _objectSpread(_objectSpread({}, taggingInfo), {}, {
        event: 'cms-component',
        eventType: newEvent,
        componentUuid: componentUuid
      });

      event.customizerId = customizerId;

      if (status === FETCHING) {
        _this.componentUuid = _gerenciatdUtils.api.getUUID('', '', false);
        event.componentUuid = _this.componentUuid;
      }

      if (!event.componentVariation) {
        event.componentVariation = '';
      }

      if (!event.componentContent) {
        event.componentContent = '';
      }

      if (!event.componentProduct) {
        event.componentProduct = '';
      }

      return event;
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      /* tagWhenMounted BEGINS */
      var _this$props2 = _this.props,
          tagWhenMounted = _this$props2.tagWhenMounted,
          status = _this$props2.status;

      if (tagWhenMounted && status) {
        var domTagged = document.getElementById(_this.taggedComponentUuid);

        if (domTagged) {
          var event = _this.buildEventObj('print', status);

          (0, _gerenciatdUtils2.sendCMSEvent)(event, status);
        }
      }
      /* tagWhenMounted ends */

    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      // Envio de eventos
      var _assertThisInitialize2 = _assertThisInitialized(_this),
          errorFound = _assertThisInitialize2.errorFound;

      var status = _this.props.status;

      if (!errorFound && status === SUCCESS && prevProps.status !== SUCCESS) {
        var domTagged = document.getElementById(_this.taggedComponentUuid);

        if (domTagged) {
          var event = _this.buildEventObj('print', status);

          (0, _gerenciatdUtils2.sendCMSEvent)(event, status);
        }
      } // alarmo en función de los datos obtenidos


      if (!errorFound && prevProps.status !== status && status === FETCHING) {
        var _event = _this.buildEventObj('print', status);

        (0, _gerenciatdUtils2.sendCMSEvent)(_event, status);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidCatch", function (error, info) {
      var id = _this.props.id;

      var event = _this.buildEventObj('print', ERROR); // we must append error


      event.componentErrorDetail = error.toString();
      (0, _gerenciatdUtils3.errorLog)("[".concat(id, "]: ").concat(event.componentErrorDetail));
      (0, _gerenciatdUtils3.errorLog)("[".concat(id, "-trace]: ").concat(info));
      (0, _gerenciatdUtils2.sendCMSEvent)(event);
      (0, _gerenciatdUtils3.infoLog)('print-error'); // debo monitorizar

      _this.errorFound = true;
    });

    _this.state = {};
    _this.taggedComponentUuid = _gerenciatdUtils.api.getUUID('', '', false);
    _this.componentUuid = -1;
    _this.errorFound = false;
    return _this;
  }

  _createClass(TaggedComponent, [{
    key: "render",
    value: function render() {
      var errorFound = this.errorFound;
      var visible = this.props.visible;
      var _this$props3 = this.props,
          children = _this$props3.children,
          WaitingComponent = _this$props3.WaitingComponent,
          errorComponents = _this$props3.errorComponents,
          status = _this$props3.status,
          id = _this$props3.id;

      if (typeof visible === 'string') {
        visible = visible.toLowerCase() === 'true';
      }

      if (!id) {
        (0, _gerenciatdUtils3.errorLog)('[TaggedComponent]: id prop is necesary for tagging fetching and error');
      }

      var CompileError = errorComponents.CompileError,
          NetworkError = errorComponents.NetworkError;

      if (errorFound) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(CompileError, {});
      }

      if (status && status === ERROR && NetworkError) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(NetworkError, {});
      }

      if (status && status === FETCHING) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(WaitingComponent, {});
      } // eslint-disable-next-line eqeqeq


      if (visible == true && status && status === SUCCESS) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          id: this.taggedComponentUuid,
          children: children
        });
      }

      return null;
    }
  }]);

  return TaggedComponent;
}(_react.Component);

TaggedComponent.propTypes = {
  id: _propTypes["default"].string.isRequired,

  /**
   * {
   *  "info": "Indica creatividad de custo que se pretende taguear",
   *  "kind": "playground",
   *  "beautifulName": "Idcreatividad custo"
   * }
   */
  customizerId: _propTypes["default"].string,
  visible: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),

  /**
   * {
   *  "info": "Define el componente que se devolverá en caso de exito en el taggeo",
   *  "kind": "playground",
   *  "beautifulName": "Componente para exito"
   * }
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * {
   *  "info": "Define el componente que se devolverá para la espera mientras se realiza el taggeo",
   *  "kind": "playground",
   *  "beautifulName": "Componente espera"
   * }
   */
  WaitingComponent: _propTypes["default"].func,

  /**
   * {
   *  "info": "Define el componente que se devolverán en caso de error durante el taggeo; dos tipos: CompileError y NetworkError",
   *  "kind": "playground",
   *  "beautifulName": "Componentes para error"
   * }
   */
  errorComponents: _propTypes["default"].shape({
    /**
     * {
     *  "info": "Define el componente que se devolverá en caso de error de compilación en el taggeo",
     *  "kind": "playground",
     *  "beautifulName": "Error de compilación "
     * }
     */
    CompileError: _propTypes["default"].func,

    /**
    * {
    *  "info": "Define el componente que se devolverá en caso de error de red en el taggeo",
    *  "kind": "playground",
    *  "beautifulName": "Error de red"
    * }
    */
    NetworkError: _propTypes["default"].func
  }),

  /**
   * {
   *  "info": "Envía un evento al montarse el componente, útil para situaciones en las que solo se quiere alarmar una aparición sin petición, status debe de ser diferente de null",
   *  "kind": "both",
   *  "beautifulName": "Tageo tras render"
   * }
   */
  tagWhenMounted: _propTypes["default"].bool,

  /**
   * {
   *  "info": "Establece los diferentes estados que pueden haber durante el taggeo, es importante que si es secuencia comience desde null, hasta succes ó error",
   *  "kind": "both",
   *  "beautifulName": "Estado de taggeo"
   * }
   */
  status: _propTypes["default"].oneOf([null, SUCCESS, FETCHING, ERROR]),

  /**
   * {
   *  "info": "Permite contribuir la infomación que será enviada a analítica tras la interacción (objeto para el taggeado)",
   *  "kind": "both",
   *  "beautifulName": "Propiedades tagueo"
   * }
   */
  taggingInfo: _propTypes["default"].object
};
TaggedComponent.defaultProps = {
  customizerId: '',
  visible: true,
  WaitingComponent: function WaitingComponent() {
    return null;
  },
  errorComponents: {
    CompileError: function CompileError() {
      return null;
    },
    NetworkError: function NetworkError() {
      return null;
    }
  },
  tagWhenMounted: false,
  status: null,
  taggingInfo: null
};
var _default = TaggedComponent;
exports["default"] = _default;

//# sourceMappingURL=index.js.map